import { useIntl } from 'react-intl';

import { PipsSlider } from '@/components/PipsSlider/PipsSlider';

import { getDurationValue } from './helper';
import type { V12Product } from './type';

import * as M from './messages';

interface DurationSliderProps {
  loanProducts: V12Product[];
  onChange: (value: V12Product) => void;
  value?: V12Product;
}

export const DurationSlider = ({
  loanProducts,
  onChange,
  value,
}: DurationSliderProps) => {
  const { formatMessage } = useIntl();
  const max = loanProducts.length - 1;
  const markLabels: Record<number, string> = {};
  loanProducts.forEach((item, index) => {
    markLabels[index] = `${String(item.months)} ${formatMessage(
      M.defined.months,
    )}`;
  });

  const handleChange = (value: number) => {
    onChange(loanProducts[value]);
  };

  const v = getDurationValue(loanProducts, value);

  return (
    <PipsSlider
      className='duration-slider'
      markLabels={markLabels}
      marks={true}
      max={max}
      min={0}
      onChange={handleChange}
      value={v}
    />
  );
};
